import React from 'react';
import DictSelect, { useDictText } from './DictSelect';
import { useDictOptions } from '../utils/dictOptions';
import SearchSelect from './SearchSelect';
import { selLayoutCls } from '../utils/searchOptions';

// SKU 属性 (material_sku.prop) 公共控件 (2026-09-23 字典化): 选项与中文名一律来自字典 sku_prop
// (种子 raw 原材料 / semi_finished 半成品), 不在页面抄常量表; 空串 = 未标.
// SKU 库 / 材料详情 / 新建向导 / 导出 共用, 不各画一份.

/** SKU 属性字典类目 (与后端 models.DictCategorySkuProp 一致). */
const SKU_PROP_DICT = 'sku_prop';

/** 编辑/新建用的字典下拉 (空值 = 未标). */
export function SkuPropSelect({
    value,
    onChange,
    className,
}: {
    value: string;
    onChange: (v: string) => void;
    className?: string;
}) {
    return (
        <DictSelect
            category={SKU_PROP_DICT}
            className={className}
            value={value}
            onChange={onChange}
            emptyLabel="未标"
            hideCode
        />
    );
}

/** 列表/导出的筛选下拉: '' 全部 / 字典条目 / 'none' 未标 (后端 SkuQuery.Prop 口径). */
export function SkuPropFilter({
    value,
    onChange,
    className,
    allLabel = '全部属性',
    title,
}: {
    value: string;
    onChange: (v: string) => void;
    className?: string;
    allLabel?: string;
    title?: string;
}) {
    const opts = useDictOptions([SKU_PROP_DICT])[SKU_PROP_DICT] || [];
    return (
        <span title={title} className="contents">
            <SearchSelect
                className={selLayoutCls(className)}
                value={value}
                onChange={(v) => onChange(v)}
                placeholder={allLabel}
                options={[
                    ...opts.map((o) => ({ value: o.code, label: o.label })),
                    { value: 'none', label: '未标' },
                ]}
                clearable
            />
        </span>
    );
}

/** 表格里的属性标签; 未标显示灰色 "—", 字典未收录的 code 原样显示. */
export function SkuPropTag({ code }: { code?: string }) {
    const text = useDictText(SKU_PROP_DICT);
    if (!code) return <span className="text-slate-300">—</span>;
    return <span className="tag bg-brand-50 text-brand-700">{text(code)}</span>;
}
